import { render, staticRenderFns } from "./ProductPriceCard.vue?vue&type=template&id=99ed602a&scoped=true&"
import script from "./ProductPriceCard.vue?vue&type=script&lang=js&"
export * from "./ProductPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductPriceCard.vue?vue&type=style&index=1&id=99ed602a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ed602a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VCard,VCheckbox,VChip,VDivider,VIcon})
